import styled from "styled-components";
const ParentsPageDisplay = styled.div`
	// my css here
`;	export default ParentsPageDisplay;
